import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { login } from '../services/api';

export default function Login() {
  const [form, setForm] = useState({ email: '', senha: '' });
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const { loginUser } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!form.email || !form.senha) return setErro('Preencha todos os campos');
    setLoading(true); setErro('');
    try {
      const r = await login(form.email, form.senha);
      loginUser(r.data.token, r.data.usuario);
      navigate(r.data.usuario.is_admin ? '/admin' : '/');
    } catch (e) {
      setErro(e.response?.data?.error || 'Erro ao fazer login');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ padding: 20 }}>
      <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 12, padding: 24, marginTop: 20 }}>
        <h1 style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: 28, color: 'var(--red)', marginBottom: 4 }}>FAZER LOGIN</h1>
        <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 20 }}>Entre na sua conta</p>
        {erro && <div style={{ background: 'rgba(230,48,48,.15)', border: '1px solid rgba(230,48,48,.3)', color: 'var(--red)', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 14 }}>{erro}</div>}
        <div className="input-group">
          <label className="input-label">E-mail</label>
          <input className="input-field" type="email" placeholder="seu@email.com" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} />
        </div>
        <div className="input-group">
          <label className="input-label">Senha</label>
          <input className="input-field" type="password" placeholder="••••••••" value={form.senha} onChange={e => setForm(p => ({ ...p, senha: e.target.value }))} onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
        </div>
        <button className="btn-primary" onClick={handleSubmit} disabled={loading}>{loading ? '⏳ Entrando...' : 'Entrar →'}</button>
        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: 'var(--text2)' }}>
          Não tem conta? <Link to="/cadastro" style={{ color: 'var(--orange)' }}>Cadastre-se grátis</Link>
        </p>
      </div>
    </div>
  );
}
